import type { SVGProps } from "react";

export default function SolarDangerCircleLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"/><path strokeLinecap="round" d="M12 7V13"/><path strokeLinecap="round" strokeLinejoin="round" d="M12 16H12.0001"/></g></svg>
  );
}
